"use client";

import { styled } from "styled-components";

export const Anchor = styled.div`
  display: flex;
  width: 100%;
  min-width: 0;
`;

export const Portal = styled.div<{
  $anchorRect: {
    top: number;
    bottom: number;
    left: number;
    right: number;
  };
  $position: "left" | "right";
  $verticalPosition: "top" | "bottom";
  $maxWidth: string;
}>`
  position: fixed;
  ${({ $anchorRect, $verticalPosition }) => {
    const top =
      $verticalPosition === "top"
        ? $anchorRect.top - 4
        : $anchorRect.bottom + 4;
    return `top: ${top}px;`;
  }}
  ${({ $anchorRect, $position }) =>
    $position === "left"
      ? `left: ${$anchorRect.left}px;`
      : `right: calc(100vw - ${$anchorRect.right}px);`}
  transform: ${({ $verticalPosition }) =>
    $verticalPosition === "top" ? "translateY(-100%)" : "none"};
  z-index: 1000;
  width: max-content;
  max-width: ${({ $anchorRect, $position, $maxWidth }) => {
    const availableWidth =
      $position === "left"
        ? `calc(100vw - ${$anchorRect.left}px - 0.8rem)`
        : `calc(${$anchorRect.right}px - 0.8rem)`;

    return `min(${$maxWidth}, ${availableWidth})`;
  }};
  pointer-events: none;
`;

export const Box = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: center;
  width: 100%;
  padding: 0.4rem;
  border: 1px solid #e5e7eb;
  border-radius: 0.4rem;
  background: #fff;
  box-shadow: 0 2px 2px 0 rgba(0, 0, 0, 0.16), 0 0 1px 0 rgba(0, 0, 0, 0.12);
`;
